import type { Product } from "@/components/marketplace/types"
import type { FeedCategoryItem, FeedProduct } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { DEFAULT_CURRENCY, money } from "@/lib/money"

export { deriveSearchPricing, mapSearchProduct } from "@/components/marketplace/map-search-product"

export const feedMoney = (amount: string) => money(amount, DEFAULT_CURRENCY)

const CHIP_BY_BADGE = { freeship: "freeship", nointerest: "noint" } as const

const feedProductChips = (product: FeedProduct) => {
  const chips = (product.badges ?? []).filter((badge): badge is keyof typeof CHIP_BY_BADGE => badge !== "nuevo").map((badge) => CHIP_BY_BADGE[badge])
  return chips.length > 0 ? chips : undefined
}

export const mapFeedProduct = (product: FeedProduct, countryCode: string): Product => {
  const badges = product.badges ?? []
  return {
    id: product.id,
    title: product.title,
    brand: product.brand,
    price: feedMoney(product.price),
    was: product.compareAtPrice != null ? feedMoney(product.compareAtPrice) : undefined,
    payments: feedMoney(product.installmentAmount),
    installments: product.installmentCount,
    financingMode: product.financingMode,
    paymentCadence: product.paymentCadence,
    downPayment: product.downPayment != null ? feedMoney(product.downPayment) : undefined,
    image: product.image.url,
    chips: feedProductChips(product),
    discount: product.discountPercent,
    isNew: badges.includes("nuevo") || undefined,
    rating: product.rating,
    reviewCount: product.reviewCount,
    href: resolveFeedLink(product.link, countryCode),
    serveId: product.serveId,
  }
}

export const mapFeedCategoryItem = (item: FeedCategoryItem, countryCode: string) => ({
  id: item.id,
  label: item.label,
  image: item.image.url,
  objectPosition: item.image.objectPosition,
  count: item.count,
  copy: item.copy,
  alt: item.alt ?? item.image.alt,
  href: resolveFeedLink(item.link, countryCode),
  serveId: item.serveId,
})
